/**
 * contiene la información para el manejo de productos de generales.
 */
export const defaultProducto = () => {
    return {
        Idproducto: '',
        activo: 1,
        verificado: 0,
        nombre: '',
        sinonimos: '',
        componentesactivos: '',
        componentesactivosIngles: '',
        cas: '',
        estado: '',
        proveedorfabricante: '',
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    // selectedProduct: defaultProducto(),
    selectedProduct: {
        Idproducto: '',
        activo: 1,
        verificado: 0,
        nombre: '',
        sinonimos: '',
        componentesactivos: [],
        componentesactivosIngles: '',
        cas: '',
        estado: '',
        proveedorfabricante: '',
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
    },
    empresas: [],
    productos: [],
    estados: [],
    bases: [],
    areas: [],
    campos: [],
    control_existe: [],
    accion: 'create',
    error: '',
    esAdmin: false,
    esEmpresa: false,
    filtro: {
        contratista: 0,
        empresa: "",
        nombre: "",
        sinonimos: "",
        proveedorfabricante: "",
        confecha: [],
        base: "",
        area: "",
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    camposPersonalizados:[],
    list_basesareas:[],
    tlvs:[],
    iarcs:[],
    otos:[],
    neuros:[],
    scs:[],
    bios:[],
    repros:[],
    mutas:[],
    teras:[]
}
